export default {
  state: {
    inProgressInvoice: [],
    qtyInProgressInvoice: 0,
    completedInvoice: [],
    qtyCompletedInvoice: 0,
    router: [],
    inProgress: 0,
    completed: 0,
    invoices: [],
    completedInvoices: [],
  },
  mutations: {
    setQtyInProgressInvoice(state, payload) {
      state.qtyInProgressInvoice = payload
    },
    setQtyCompletedInvoice(state, payload) {
      state.qtyCompletedInvoice = payload
    },
    setInProgressInvoice(state, payload) {
      state.inProgressInvoice = []
      state.inProgressInvoice.push(...payload)
    },
    setCompletedInvoice(state, payload) {
      state.completedInvoice = []
      state.completedInvoice.push(...payload)
    },
    setRouterInvoice(state, payload) {
      state.router[payload.name] = payload.value
    },
    setInvoices(state, payload) {
      state.invoices = payload
    },
    setCompletedInvoices(state, payload) {
      state.completedInvoices = payload
    },
    setRouterInvoices(state, payload) {
      state.router[payload.name] = payload.value
    },
    setMetaInvoice(state, payload) {
      state.meta[payload.name] = payload.value
    }
  },
  actions: {
    setQtyInProgressInvoice({commit}, payload) {
      commit('setQtyInProgressInvoice', payload)
    },
    setQtyCompletedInvoice({commit}, payload) {
      commit('setQtyCompletedInvoice', payload)
    },
    setInProgressInvoice({commit}, payload) {
      commit('setInProgressInvoice', payload)
    },
    setCompletedInvoice({commit}, payload) {
      commit('setCompletedInvoice', payload)
    },
    setRouterInvoice({commit}, payload) {
      commit('setRouterInvoice', payload)
    },
    setInvoices({commit}, payload) {
      commit('setInvoices', payload)
    },
    setCompletedInvoices({commit}, payload) {
      commit('setCompletedInvoices', payload)
    },
    setRouterInvoices({commit}, payload) {
      commit('setRouterInvoices', payload)
    },
  },
  getters: {
    getRouterInvoice(state) {
      return state.router
    },
    getInProgressInvoice(state) {
      return state.inProgressInvoice
    },
    getInProgressInvoiceKey(state) {
      return state.inProgressInvoice
    },
    getCompletedInvoice(state) {
      return state.completedInvoice
    },
    getQtyInProgressInvoice(state) {
      return state.qtyInProgressInvoice
    },
    getQtyCompletedInvoice(state) {
      return state.qtyCompletedInvoice
    },
    invoices(state) {
      return state.inProgressInvoice
    },
    completedInvoices(state) {
      return state.completedInvoice
    }
  }
}
